import React from "react";
import styled from "styled-components";
import { EditorBlock, genKey } from "draft-js";

const SectionContainer = styled.div`
  display: flex;
  margin: 16px 16px 16px 16px;
`;

const Icon = styled.button`
  height: 50px;
  width: 50px;
  min-height: 50px;
  min-width: 50px;
  padding: 0px;
  background-color: ${props =>
    props.isTQRBubble || props.needsRevision
      ? props.type === "CustomerBubble"
        ? "#F23D60"
        : "#3479FF"
      : "#D3D3D3"};
  color: white;
  border: none;
  border-radius: 50%;
  text-decoration: none;
  margin-${props => (props.type === "CustomerBubble" ? "left" : "right")}: 8px;
`;

const TextContainer = styled.div`
  background-color: ${props =>
    props.isTQRBubble || props.needsRevision
      ? props.type === "CustomerBubble"
        ? "#F23D60"
        : "#3479FF"
      : "#D3D3D3"};
  padding: 1em;
  border-radius: 1em;
  color: white;
  flex-grow: 1;
  font-size: 1.2em;
  line-height: 1.3em;

  :selection {
    background-color: ${props =>
    props.type === "CustomerBubble" ? "#000000" : "#000000"};
  }
`;

const EditReasonsContainer = styled.div`
  background-color: #ffd075;
  color: #8f5f00 !important;
  margin: 10px;
  padding: 1em;
  border-radius: 1em;
  color: white;
  flex-grow: 0;
  font-size: 1.2em;
  line-height: 1.3em;
`;

class SpeakerBubble extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      type,
      secondPass,
      onIconClick,
      needsRevision,
      eventQualityReasons,
      hasEvents,
      hideEventQualityReasons,
      propagateQualityReasonCallback,
    } = this.props.blockProps;

    const isTQRBubble = propagateQualityReasonCallback !== undefined;
    const showEditReasons =
      !secondPass &&
      hasEvents &&
      !hideEventQualityReasons &&
      !isTQRBubble &&
      needsRevision;

    // TODO: handle isTQRBubble more cleanly -- it currently relies on
    //  SpeakerBubbles created in different contexts being initialized with
    //  different blockProps (propagateQualityReasonCallback is present for TQR)
    return (
      <SectionContainer>
        {type === "CustomerBubble" ? (
          <React.Fragment>
            {showEditReasons ? (
              <EditReasonsContainer contentEditable={false}>
                Problems that require editing:
                <ul key={genKey()}>
                  {Object.values(eventQualityReasons).map(function(
                    editReasonLabel
                  ) {
                    return <li key={genKey()}>- {editReasonLabel}</li>;
                  })}
                </ul>
              </EditReasonsContainer>
            ) : (
              ""
            )}
            <TextContainer
              isTQRBubble={isTQRBubble}
              needsRevision={needsRevision}
              type={type}
            >
              <EditorBlock {...this.props} />
            </TextContainer>
            <Icon
              isTQRBubble={isTQRBubble}
              needsRevision={needsRevision}
              contentEditable={false}
              type={type}
              onClick={() => {
                if (needsRevision) {
                  onIconClick(this.props.block.getKey());
                }
              }}
            >
              Cust
            </Icon>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Icon
              isTQRBubble={isTQRBubble}
              needsRevision={needsRevision}
              contentEditable={false}
              type={type}
              onClick={() => {
                if (needsRevision) {
                  onIconClick(this.props.block.getKey());
                }
              }}
            >
              Rep
            </Icon>
            <TextContainer
              isTQRBubble={isTQRBubble}
              needsRevision={needsRevision}
              type={type}
            >
              <EditorBlock {...this.props} />
            </TextContainer>
            {showEditReasons ? (
              <EditReasonsContainer contentEditable={false}>
                Problems that require editing:
                <ul>
                  {Object.values(eventQualityReasons).map(function(
                    editReasonLabel
                  ) {
                    return <li key={genKey()}>- {editReasonLabel}</li>;
                  })}
                </ul>
              </EditReasonsContainer>
            ) : (
              ""
            )}
          </React.Fragment>
        )}
      </SectionContainer>
    );
  }
}

export default SpeakerBubble;
